import PropTypes from 'prop-types';
import React from 'react';

import Tag from 'components/tags/Tag';
import getDateFromTimestamp from 'utils/date/getDateFromTimestamp';

const SweetheartListJournalistContacted = ({
  journalist = {},
  status = '',
  date = '',
}) => {
  const bgColor = status === 'active' ? 'blue-100' : 'green-100';
  const textColor = status === 'active' ? 'blue-500' : 'green-500';
  let formattedDate = getDateFromTimestamp(date);

  if (formattedDate === 'Today') {
    formattedDate = 'today';
  } else {
    formattedDate = `on ${formattedDate}`;
  }

  return (
    <Tag
      bgColor={bgColor}
      textColor={textColor}
      data-test-id={`sweetheartListJournalist-startConversation-${journalist.name}-tag`}
    >
      {status === 'active' ? 'Contacted ' : 'Draft created '}
      {formattedDate}
    </Tag>
  );
};

SweetheartListJournalistContacted.propTypes = {
  journalist: PropTypes.object.isRequired,
  status: PropTypes.string,
  date: PropTypes.string,
};

export default SweetheartListJournalistContacted;
